import styled from 'styled-components';

export const ThumbnailBox = styled.div<{ $preview: boolean }>`
  align-items: center;
  background: ${(props) => props.theme.colors.background};
  border-radius: ${(props) => (props.$preview ? '1rem' : '0.75rem')};
  box-sizing: border-box;
  color: ${(props) => props.theme.colors.textLight};
  display: flex;
  flex-shrink: 0;
  height: ${(props) => (props.$preview ? '10rem' : '5rem')};
  justify-content: center;
  overflow: hidden;
  width: ${(props) => (props.$preview ? '10rem' : '5rem')};
`;

export const ThumbnailButton = styled.button<{ $preview: boolean }>`
  background: transparent;
  border: 0;
  border-radius: ${(props) => (props.$preview ? '1rem' : '0.75rem')};
  cursor: pointer;
  display: block;
  padding: 0;
  position: relative;

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 3px;
  }

  &:hover {
    filter: brightness(0.96);
  }
`;

export const ImageCount = styled.span`
  background: rgba(0, 0, 0, 0.72);
  border-radius: 999px;
  bottom: 0.2rem;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 0.16rem 0.4rem;
  position: absolute;
  right: 0.2rem;
`;

export const ThumbnailImage = styled.img`
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const ThumbnailFallback = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;
